<template>
    <div class="container_product_list">
        <section :class="['product_list product_seccion', sectionActive === i.id ? 'active' : '']" v-for="(i, idx) in listMain" :key="idx" :id="'section-'+i.id" :data-row="i.id">
            <!-- <edit-category-name :indicador="i.id" :cat="i"></edit-category-name> -->
            <draggable v-model="i.products" tag="div" v-bind="dragOptions" @change="checkMove(i.products)" @start="isDragging = true" @end="isDragging = false" handle=".handle">
                <article v-for="(product, index) in i.products" :key="index" :data-indicador="i.id" :class="['product_item_container']">
                    <!-- {{ product }} -->
                    <div class="handle"><i class="fas fa-arrows-alt-v"></i></div>
                    <div :class="['product_item', product.visibility_status=='hidden' ? 'product_item_hidden' : '']" :data-indicador="i.id">
                        <header class="product_item_header" :data-indicador="i.id">
                            <edit-product-name :indicador="i.id" :product="product"></edit-product-name>
                        </header>
                        <slider-media
                            :indicador="i.id"
                            :productItem="product"
                            :gallery="product.gallery"
                            :urlMedia="urlMedia"
                            @editGallery="$emit('clickAction', $event)"
                            @clickNav="goToSlide($event)"
                        >
                        </slider-media>
                        <aside>
                            <edit-product-price :indicador="i.id" :product="product" @openEditPrice="showEditPrice($event)"></edit-product-price>
                        </aside>
                        <footer>
                            <edit-product-details :indicador="i.id" :product="product"></edit-product-details>
                            <btns-cart :indicador="i.id" :product="product"></btns-cart>
                        </footer>
                        <opts-price :indicador="i.id" :product="product" :editPriceActive="editPriceActive" @closeEditPrice="showEditPrice($event)"></opts-price>
                    </div>
                </article>
            </draggable>
            <div class="add_product_new text-center">
                <button class="btn btn-primary btn-xs" @click.prevent="addproduct(i)" :disabled="loadSave"><i class="fas fa-chevron-up"></i> {{ lang.bspl_new_item }}</button>
            </div>
        </section>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import draggable from 'vuedraggable'
// import productCategory from "./productCategory.vue"
import productEditName from "./productEditName.vue"
import productEditPrice from "./productEditPrice.vue"
import productEditDescription from "./productEditDescription.vue"
import btnsCart from "./btns_cart.vue"
import productSlider from "./productSlider.vue";
import OptsPrice from "./optsPrice.vue";
export default {
    props: ['urlMedia', 'sectionActive'],
    components: {
        draggable,
        // 'edit-category-name': productCategory,
        'edit-product-name': productEditName,
        'edit-product-price': productEditPrice,
        'edit-product-details': productEditDescription,
        'slider-media': productSlider,
        'btns-cart': btnsCart,
        'opts-price': OptsPrice,
    },
    data(){
        return {
            lang: {
                bspl_new_item: '',
                bspl_product_name_ph: '',
                bs_error: '',
                bs_could_not_save: '',
            },
            apis: null,
            coordenadas: null,
            currentCoord: null,
            scrollingValue: 0,
            coordIndex: 0,
            listMain: [],
            playVideo: false,
            loadSave: false,
            editPriceActive: false,
            details: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quia provident eum iusto! Eveniet, reprehenderit quod. Eaque unde fuga dicta necessitatibus! Corrupti odio tempore totam ratione nulla eius velit provident porro',
        };
    },
    created() {
        let t = this;
        this.lang = this.$store.getters['ModApps/Marketea/lang'];
        let urlApis = this.$store.getters['ModApps/Marketea/urlApis'];
        this.apis = urlApis.bStore;
        t.listMain = t.$store.getters['ModApps/Marketea/get_bStore_listCat'];
    },
    beforeDestroy() {
    },
    computed: {
        ...mapGetters("ModApps/Marketea/", {
            getListCat: "get_bStore_listCat",
            getCatActive: "get_bStore_catActive",
            langGetter: "lang",
        }),
        dragOptions() {
            return {
                animation: 200,
                group: "gallery",
                disabled: false,
                ghostClass: "ghost",
            };
        },
    },
    watch: {
        langGetter() { this.lang = this.$store.getters['ModApps/Marketea/lang']; },
        getListCat: function(newVal, oldVal){
            let t = this;
            t.updateList(newVal);
        },
    },
    mounted(){
        this.get_currency();
        this.get_bStoreInfo();
        this.startSlider();
    },
    methods: {
        showEditPrice($event) {
            console.log('showEditPrice', $event);
            this.editPriceActive = $event || false;
        },
        updateList(list){
            this.listMain = list;
            this.startSlider();
        },
        startSlider() {
            this.$nextTick(() => {
                const sliders = document.querySelectorAll('.product_gallery_slider');
                if (!sliders.length) return;
                // console.log('Initializing sliders', sliders);
                sliders.forEach(slider => this.sliderEvent(slider));
            });
        },
        sliderEvent(slider) {
            if (!slider) return;
            const sliderId = slider.dataset.slider;
            const slides = slider.querySelectorAll('ul li');
            const navItems = document.querySelectorAll(
                `#product_item_content_media_${sliderId} a[class^="nav-item"]`
            ) || [];
            let isDragging = false;
            let startX = 0;
            let scrollStart = 0;
            let activeIndex = 0;
            let ticking = false;
            slider.style.maxHeight = 'min(600px, 80vh)';
            slider.style.cursor = 'grab';
            /* ------------------------------
            DRAG
            ------------------------------ */
            const onPointerDown = (e) => {
                isDragging = true;
                slider.setPointerCapture(e.pointerId);
                startX = e.clientX;
                scrollStart = slider.scrollLeft;
                slider.classList.add('dragging');
                slider.style.userSelect = 'none';
            };
            const onPointerMove = (e) => {
                if (!isDragging) return;
                const dx = e.clientX - startX;
                slider.scrollLeft = scrollStart - dx * 1.2;
            };
            const onPointerUp = (e) => {
                isDragging = false;
                try { slider.releasePointerCapture(e.pointerId); } catch (err) {}
                slider.classList.remove('dragging');
                slider.style.userSelect = '';
            };
            slider.addEventListener('pointerdown', onPointerDown);
            slider.addEventListener('pointermove', onPointerMove);
            slider.addEventListener('pointerup', onPointerUp);
            slider.addEventListener('pointerleave', onPointerUp);
            /* ------------------------------
            ACTIVE SLIDE
            ------------------------------ */
            const updateActiveSlide = () => {
                const sliderRect = slider.getBoundingClientRect();
                let closest = null;
                let closestOffset = Infinity;
                slides.forEach((slide, index) => {
                    const rect = slide.getBoundingClientRect();
                    const offset = Math.abs(rect.left - sliderRect.left);
                    if (offset < closestOffset) {
                        closestOffset = offset;
                        closest = slide;
                        activeIndex = index;
                    }
                });
                slides.forEach(s => s.classList.remove('active'));
                navItems.forEach(n => n.classList.remove('active'));
                if (closest) {
                    closest.classList.add('active');
                    if (navItems[activeIndex]) {
                        navItems[activeIndex].classList.add('active');
                    }
                }
                detectRatio();
            };
            slider.addEventListener('scroll', () => {
                if (!ticking) {
                    window.requestAnimationFrame(() => {
                        updateActiveSlide();
                        ticking = false;
                    });
                    ticking = true;
                }
            });
            /* ------------------------------
            ASPECT RATIO DINÁMICO
            ------------------------------ */
            function detectRatio() {
                // Use the active slide if available (set by updateActiveSlide), fallback to first
                const activeSlide = slider.querySelector('li.active') || slider.querySelector('li');
                if (!activeSlide) return;
                const media = activeSlide.querySelector('img, video');
                if (!media) return;

                const applyRatio = (width, height) => {
                    const ratio = width / height;
                    // Limitar proporciones extremas
                    const minRatio = 0.6;  // muy vertical
                    const maxRatio = 1.8;  // muy horizontal
                    const safeRatio = Math.min(Math.max(ratio, minRatio), maxRatio);
                    slider.style.aspectRatio = safeRatio;
                    slider.style.maxHeight = 'min(600px, 80vh)';
                    // Update helper classes for styling variants
                    slider.classList.remove('ratio-vertical', 'ratio-horizontal', 'ratio-square');
                    if (safeRatio <= 0.9) slider.classList.add('ratio-vertical');
                    else if (safeRatio >= 1.3) slider.classList.add('ratio-horizontal');
                    else slider.classList.add('ratio-square');
                };

                const handleImage = () => applyRatio(media.naturalWidth, media.naturalHeight);
                const handleVideo = () => applyRatio(media.videoWidth, media.videoHeight);

                if (media.tagName === 'IMG') {
                    if (media.complete && media.naturalWidth && media.naturalHeight) {
                        handleImage();
                    } else {
                        media.addEventListener('load', handleImage, { once: true });
                    }
                } else if (media.tagName === 'VIDEO') {
                    if (media.readyState >= 1 && media.videoWidth && media.videoHeight) {
                        handleVideo();
                    } else {
                        media.addEventListener('loadedmetadata', handleVideo, { once: true });
                    }
                }
            }
            detectRatio();
            window.addEventListener('resize', detectRatio);
            /* ------------------------------
            INIT
            ------------------------------ */
            updateActiveSlide();
        },
        goToSlide(event){
            // Resolve indicador (slider identifier)
            const indicador = event && (event.indicador ?? event.indicator ?? null);
            // Locate slider by data-slider attribute first, fallback to id
            this.currentSlider = null;
            if (indicador !== null) {
                this.currentSlider = document.querySelector(`.product_gallery_slider[data-slider="${indicador}"]`) ||
                document.querySelector(`#product_gallery_slider${indicador}`);
            }
            const slides = this.currentSlider.querySelectorAll('ul li');
            if(!slides || !slides.length) return;
            // Determine requested slide target. `SliderId` coming from the child is the gallery item id,
            // not the zero-based index. We must resolve it to the slide index.
            let index = 0;
            if (typeof event === 'number') index = event;
            else if (event && (event.SliderId != null)) {
                // find slide whose data-itemg equals SliderId
                const targetId = String(event.SliderId);
                let foundIndex = -1;
                slides.forEach((s, idx) => {
                    const itemg = s.dataset.itemg ?? s.getAttribute('data-itemg') ?? s.id ?? '';
                    if (String(itemg) === targetId) foundIndex = idx;
                });
                if (foundIndex !== -1) index = foundIndex;
                else index = Number(event.SliderId) || 0; // fallback if SliderId was actually an index
            }
            else if (event && (event.sliderId != null)) index = Number(event.sliderId);
            else if (event && (event.index != null)) index = Number(event.index);
            if(!this.currentSlider) {
                console.warn('goToSlide: slider not found for indicador', indicador);
                return;
            }
            // Clamp index within bounds
            const clamped = Math.max(0, Math.min(index, slides.length - 1));
            const target = slides[clamped];
            if (!target) return;
            // Calculate exact left using offsetLeft of the target slide
            let left = target.offsetLeft;
            // Ensure we don't exceed maximum scrollable area
            const maxLeft = this.currentSlider.scrollWidth - this.currentSlider.clientWidth;
            if (left > maxLeft) left = maxLeft;
            console.log('goToSlide', {index, clamped, left, maxLeft});
            this.currentSlider.scrollTo({ left, behavior: 'smooth' });
        },
        addproduct(i){
            let t= this;
            let urlService = t.apis.set(3)// setproduct
            if(!t.loadSave){
                t.loadSave = true;
                // @ts-ignore
                window.master.post(urlService, {
                    user_id: window.master_client,
                    org_id: window.localorgdata,
                    pusher_id: pusher.connection.socket_id,
                    cat_id: i.id,
                    product_name: t.lang.bspl_product_name_ph,
                    product_desc: t.details,
                    price: '0',
                })
                .then((response) => {
                    console.log(urlService, response.data);
                    t.loadSave = false;
                    if(response.data.status && response.data.get){
                        t.$store.commit('ModApps/Marketea/set_bStoreAddProducts', response.data.get);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    t.loadSave = false;
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: t.lang.bs_error,
                        text: t.lang.bs_could_not_save,
                    });
                });
            }
        },
        checkMove(products) {
            let t = this;
            products.map((item, index) => {
                item.orden = index;
            });
            console.log('move products', products)
            let urlService = t.apis.set(4)// setproductOrden
            window.master.post(urlService, {
                ordenproducts: products,
            })
            .then((response) => {
                console.log(response.data);
            })
            .catch((error) => {
                console.log(error);
                t.$notify({
                    group: "noti",
                    type: "error",
                    title: t.lang.bs_error,
                    text: t.lang.bs_could_not_save,
                });
            });
        },
        get_currency(){
            let t = this;
            t.$store.commit("core/setLoadingModal", true);
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            let urlService = t.apis.get(4)// get_currency
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                if (response.data.status && response.data.currency && response.data.currency.meta_value) {
                    t.$store.commit('ModApps/Marketea/set_bStore_currency', response.data.currency.meta_value);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        get_bStoreInfo(){
            let t = this;
            let formData = {};
            formData.user_id = window.master_client;
            formData.org_id = window.localorgdata;
            formData.pusher_id = (typeof pusher !== 'undefined' && pusher && pusher.connection)? pusher.connection.socket_id : null;
            let urlService = t.apis.get(2)// getInfo
            window.master.post(urlService, formData)
            .then((response) => {
                console.log(urlService, response.data);
                if (response.data.status && response.data.info) {
                    t.$store.commit('ModApps/Marketea/set_bStore_info', response.data.info);
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
